import React, { Component } from "react";

import { CButton, CSpinner, CSelect } from "@coreui/react";
import { connect } from "react-redux";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { bindActionCreators } from "redux";

import { login, tryLogin } from "../../actions/baseActions";
import logo from "../../assets/imgs/logo_original.png";
import ProtectedRoute from "../../components/ProtectedRoute";
import URL from "../../config/api";
import axios from "../../config/axios";

import "./style.css";

class AllocationFinder extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activity_id: this.props.match.params.activity_id,
      schoolList: [],
      roomList: [],
      school_id: "",
      room_id: "",
      loading: true,
      allocation_id: "",
      searchingAllocation: false,
      validActivityId: true
    };
  }

  componentDidMount() {
    this.props.tryLogin(false);
    this.getSchoolList();
  }

  getSchoolList() {
    axios
      .get(`${URL.api}activitySchoolListAll/${this.state.activity_id}`, {})
      .then(resp => {
        if (resp.data) {
          this.setState({ schoolList: resp.data.data, loading: false });
        }
      });
  }

  getAllocation() {
    this.setState({ loading: true });
    axios
      .post(`${URL.api}AllocationFinder`, {
        activity_id: this.state.activity_id,
        room_id: this.state.room_id
      })
      .then(resp => {
        if (resp.data) {
          this.setState({ allocation_id: resp.data.data.id, loading: false });
          if (resp.data === "null" || resp.data === null) {
            this.setState({ validActivityId: false });
          } else {
            this.redirectAllocation();
          }
        }
      });
  }

  getRoomsList(schoolId) {
    this.setState({ loading: true });
    axios
      .post(`${URL.api}SchoolRoomsListAll`, {
        activity_id: this.state.activity_id,
        school_id: schoolId
      })
      .then(resp => {
        if (resp.data) {
          this.setState({ roomList: resp.data.data, loading: false });
        }
      });
  }

  redirectAllocation(allocationId) {
    window.location.href = `/activity/do/${this.state.allocation_id}`;
  }

  render() {
    const { login } = this.props;

    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="5">
              <Card className="p-4 m-0">
                <CardBody>
                  {this.state.loading ? (
                    <CSpinner
                      size="sm"
                      color="black"
                      className="mx-auto d-block"
                    />
                  ) : this.state.validActivityId ? (
                    <>
                      <div className="d-flex justify-content-start mb-4">
                        <img src={logo} alt="logo da empresa" />
                      </div>
                      <div className="card">
                        <div className="card-header">
                          <p>
                            Para levar você até a sua atividade, por favor,
                            selecione sua escola e turma.
                          </p>
                        </div>

                        <div className="card-body">
                          <div className="form-group">
                            <span>
                              <b>Primeiro</b> selecione a sua <b>Escola</b>:
                            </span>
                            <div className="p-3">
                              <CSelect
                                value={this.state.school_id}
                                onChange={e => {
                                  this.setState({ school_id: e.target.value });
                                  this.getRoomsList(e.target.value);
                                }}
                              >
                                <option value="">Selecione uma Escola</option>
                                {this.state.schoolList.map(school => (
                                  <option key={school.id} value={school.id}>
                                    {school.name}
                                  </option>
                                ))}
                              </CSelect>
                            </div>
                          </div>
                          {this.state.roomList.length > 0 && (
                            <div className="form-group">
                              <span>
                                <b>Agora</b> selecione a sua <b>Turma</b>:
                              </span>
                              <div className="p-3">
                                <CSelect
                                  value={this.state.room_id}
                                  onChange={e => {
                                    this.setState({ room_id: e.target.value });
                                  }}
                                >
                                  <option value="">Selecione uma Turma</option>
                                  {this.state.roomList.map(room => (
                                    <option key={room.id} value={room.id}>
                                      {room.name}
                                    </option>
                                  ))}
                                </CSelect>
                              </div>
                              {this.state.room_id !== "" && (
                                <CButton
                                  color="primary"
                                  className="d-flex justify-content-center align-items-center p-2"
                                  block
                                  onClick={() => this.getAllocation()}
                                >
                                  <>
                                    <span
                                      style={
                                        this.state.searchingAllocation
                                          ? { opacity: 0 }
                                          : null
                                      }
                                    >
                                      Continuar
                                    </span>
                                    {this.state.loading && (
                                      <CSpinner
                                        size="sm"
                                        color="white"
                                        style={{ position: "absolute" }}
                                      />
                                    )}
                                  </>
                                </CButton>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </>
                  ) : (
                    <h3>Atividade inválida</h3>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
          <ProtectedRoute routeId={this.props.currentRoute} />
        </Container>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      login,
      tryLogin
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(AllocationFinder);
